import { UnfoldMore } from '@mui/icons-material';
import { observer } from 'mobx-react-lite';

import { ButtonIcons } from '@/components/ButtonIcons';
import { viewSettingsStore } from '@/features/viewSettings';

const FoldButton = () => {
  const { calendarExpandAll, setCalendarExpandAll } = viewSettingsStore;

  const title = calendarExpandAll ? 'Свернуть все логи' : 'Показать все логи';

  return (
    <ButtonIcons onClick={() => setCalendarExpandAll(!calendarExpandAll)} title={title}>
      <UnfoldMore sx={{ width: '18px', height: '18px' }} />
    </ButtonIcons>
  );
};

export default observer(FoldButton);
